import {Word} from "@game/word";
import {CSSProperties} from "react";
import {THEME} from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    content: {
        display: "flex",
        justifyContent: "center",
        position: "relative"
    },
    horizontal: {
        flexDirection: "column",
        left: -16
    },
    score: {
        backgroundColor: "white",
        borderColor: "green",
        borderRadius: 18,
        borderStyle: "solid",
        borderWidth: 4,
        padding: 4,
        zIndex: 1
    },
    vertical: {
        top: -24
    }
};

interface IWordScore {
    word: Word
}
export function WordScore({word}: IWordScore) {
    const content = {
        ...styles.content,
        ...word.from.position.x === word.to.position.x ? styles.vertical : styles.horizontal
    }
    return (
        <div style={content}>
            <div style={styles.score}>
                <span style={styles.text}>{word.score}</span>
            </div>
        </div>
    );
}